module.exports = __webpack_public_path__ + "static/media/jam.d998cc1a.png";